/**
 * dataLayer push — riocarnaval.org (GTM-PRLQ9JG)
 */

function newEventId(prefix) {
    const rand = Math.random()
        .toString(36)
        .slice(2, 10);
    return `rc_${prefix}_${Date.now()}.${rand}`;
}

export function createEventId(prefix) {
    return newEventId(prefix);
}

export function getPageContext() {
    const ctx =
        (typeof window !== "undefined" && window.gtmPageContext) || {};
    return {
        locale: ctx.locale || document.documentElement.lang || "en",
        page_type: ctx.page_type || "page",
        page_path: ctx.page_path || (typeof window !== "undefined" ? window.location.pathname : ""),
        page_title: ctx.page_title || (typeof document !== "undefined" ? document.title : ""),
        template: ctx.template || null,
        affiliation: ctx.affiliation || "riocarnaval.org"
    };
}

/**
 * @param {Record<string, unknown>} payload
 */
export function pushDataLayer(payload) {
    if (typeof window === "undefined") return;

    window.dataLayer = window.dataLayer || [];

    if (Object.keys(payload).length === 1 && payload.ecommerce === null) {
        window.dataLayer.push(payload);
        return;
    }

    const page = getPageContext();
    const enriched = {
        event_id:
            typeof payload.event_id === "string"
                ? payload.event_id
                : newEventId("evt"),
        locale: page.locale,
        affiliation: page.affiliation,
        ...payload
    };

    window.dataLayer.push(enriched);
}
